/* Bewegung der Startseite.
 *
 * Grundregel (CLAUDE.md Paragraph 3): jede Section hat genau EINEN eigenen
 * Moment. Es gibt bewusst keine generische Einblend-Animation, die auf alles
 * gelegt wird - das ist der Grund, warum solche Seiten gleichfoermig wirken.
 *
 * Animiert werden nur transform, opacity und clip-path. Bei
 * prefers-reduced-motion ist alles sofort im Endzustand sichtbar; die
 * Scroll-Bindungen werden dann gar nicht erst aufgebaut.
 */
(function () {
  'use strict';

  var F = window.FLAVRBLOOM || {};
  if (!window.gsap || !window.ScrollTrigger) return;

  var gsap = window.gsap;
  var ScrollTrigger = window.ScrollTrigger;
  var reduce = F.reduce || window.matchMedia('(prefers-reduced-motion: reduce)');

  /* Pop-Kurve wie im Hero: schwingt einmal leicht ueber 1 und setzt sich. */
  gsap.registerEase('flavrPop', function (t) {
    var s = 1.70158, u = t - 1;
    return 1 + (s + 1) * u * u * u + s * u * u;
  });

  var kurz = window.matchMedia('(max-width: 47.9375rem)').matches;  /* mobil kuerzere Wege */
  var W = kurz ? 0.55 : 1;                                          /* Wegfaktor */

  /* ---------------------------------------------------------------- Helfer */

  /* Eine Ueberschrift in Zeilen zerlegen und jede in eine Maske stecken.
     Gemessen wird ueber die Oberkante der Woerter - zuverlaessiger als jede
     Schaetzung ueber Zeichenzahl. */
  function inZeilen(el) {
    if (el.dataset.zerlegt) return;
    var worte = el.textContent.trim().split(/\s+/);
    el.textContent = '';
    var messer = worte.map(function (w) {
      var s = document.createElement('span');
      s.textContent = w;
      s.style.display = 'inline-block';
      el.appendChild(s);
      el.appendChild(document.createTextNode(' '));
      return s;
    });
    var zeilen = [], letzteHoehe = null;
    messer.forEach(function (s) {
      var oben = Math.round(s.offsetTop);
      if (letzteHoehe === null || Math.abs(oben - letzteHoehe) > 4) {
        zeilen.push([]); letzteHoehe = oben;
      }
      zeilen[zeilen.length - 1].push(s.textContent);
    });
    el.textContent = '';
    zeilen.forEach(function (z) {
      var aussen = document.createElement('span');
      aussen.className = 'zeile';
      var innen = document.createElement('span');
      innen.className = 'zeile__innen';
      innen.textContent = z.join(' ');
      aussen.appendChild(innen);
      el.appendChild(aussen);
    });
    el.dataset.zerlegt = '1';
  }

  /* ?ruhe und reduzierte Bewegung: alles steht sofort im Endzustand. Jeder
     Moment, der einen Startzustand im CSS hat, muss hier aufgelaufen sein -
     sonst zeigt eine Ganzseitenaufnahme leere Flaechen. */
  function alleSichtbar() {
    document.querySelectorAll('[data-maske]').forEach(function (el) {
      el.style.visibility = 'visible';
    });
    document.querySelectorAll('.statement__wort').forEach(function (w) {
      w.style.opacity = '1';
    });
    document.querySelectorAll('[data-schuesseln] li').forEach(function (li) {
      li.style.opacity = '1';
    });
    document.querySelectorAll('.figurkarte__bild').forEach(function (b) {
      b.style.opacity = '1';
    });
    document.querySelectorAll('[data-dosen] .dose').forEach(function (d) {
      d.style.opacity = '1';
    });
  }

  /* Eine Fuellung des Statement-Satzes. gsap.matchMedia() ruft das je Breite
     einmal auf und raeumt beim Wechsel auf, wenn wir den Tween zurueckgeben. */
  function statementFuellung(worte, start, ende, nachlauf) {
    /* 24.10.2026 (Kevin: "zu schnell, wird nicht nach und nach dick"):
       gemessen fuellte sich der Satz am Handy in rund 300 px Scrollweg, und
       bei each 0.5 liefen je zwei, drei Woerter gleichzeitig - der Satz sprang
       in Gruppen. Jetzt kommt jedes Wort einzeln, das naechste beginnt, wenn
       das vorige zu drei Vierteln dunkel ist. */
    return gsap.to(worte, {
      opacity: 1,
      ease: 'none',
      stagger: { each: 0.75, from: 'start' },
      scrollTrigger: {
        /* 10.10.2026 (Kevin: "wird am Handy nicht rechtzeitig dick"): Maszstab
           ist die Ueberschrift selbst, nicht der ganze Abschnitt. Der ist am
           Handy fast zwei Bildschirme hoch, und seine Mitte kam erst, als der
           Satz schon oben aus dem Bild lief. */
        trigger: document.getElementById('statement-titel') || '.statement',
        start: start,
        end: ende,
        scrub: nachlauf
      }
    });
  }

  /* ------------------------------------------------------------- Aufbauen */

  /* ------------------------------------------------- Hero -> Statement
     Das EINZIGE Ueberfahren, das geblieben ist. Damit das Statement wirklich
     ueber den Hero faehrt und nicht mit ihm davonscrollt, bleibt der Hero
     oben kleben (css/hero.css). Er liegt unter der Seite und wird von ihr
     zugedeckt - sichtbar ist er nur, solange das Statement ihn noch nicht
     erreicht hat.

     Alle uebrigen Sections scrollen normal. Der Stapel aus klebenden
     Abschnitten ist raus: er hat die Seite schwer gemacht und bei jeder
     Ganzseitenaufnahme Sections uebereinandergelegt. Die Momente der
     einzelnen Sections bleiben unveraendert. */

  function aufbauen() {

    /* 1 Hero -> Statement
       Das Statement faehrt ueber den Hero; der Hero tritt dahinter zurueck und
       dunkelt ab. Derselbe Moment wie zwischen zwei Sections, nur dass hier
       die Buehne die Vorgaengerin ist.

       ZURUECK FAEHRT DER INHALT, NIE DIE FLAECHE. Vorher skalierte .hero als
       Ganzes auf 0,94 - dabei schrumpfte die Sortenfarbe mit und rings um sie
       wurde ein heller Rahmen sichtbar. Jetzt bleibt die Flaeche randlos und
       in voller Groesse; nur Dose, Sortenwort, Zutaten und Infoblock fahren
       zurueck. Dieselbe Regel gilt fuer jeden Uebergang im Sticky-Stack
       (CLAUDE.md Paragraph 3). */
    var hero = document.querySelector('.hero');
    var statement = document.querySelector('.statement');
    var heroInhalt = hero && hero.querySelectorAll(':scope > .track, :scope > .hud');
    if (hero && statement && heroInhalt && heroInhalt.length) {
      var heroSchleier = document.createElement('div');
      heroSchleier.className = 'hero-schleier';
      heroSchleier.setAttribute('aria-hidden', 'true');
      hero.appendChild(heroSchleier);

      gsap.timeline({
        scrollTrigger: {
          trigger: statement,
          start: 'top bottom',
          end: 'top top',
          scrub: 0.5
        }
      })
        .fromTo(heroInhalt, { scale: 1 }, { scale: 0.94, ease: 'none' }, 0)
        .fromTo(heroSchleier, { opacity: 0 }, { opacity: 0.45, ease: 'none' }, 0);
    }

    /* 2 Statement: der Satz fuellt sich Wort fuer Wort mit dem Scroll.

       Der Satz muss dunkel SEIN, bevor der Block in der Bildmitte steht - wer
       ihn dort liest, liest keine halb aufgehellten Woerter mehr.

       Frueher lief die Strecke von 'top 72%' bis 'bottom 62%'. Das Ende hing
       an der UNTERKANTE: je hoeher der Block, desto spaeter war er fertig, und
       mobil ist er am hoechsten - dort wurde der Satz erst weit hinter der
       Mitte voll. Das Ende haengt jetzt an der MITTE des Blocks und liegt
       unterhalb der Bildmitte (62 % bzw. 70 % der Fensterhoehe), also
       nachweislich davor. Die Strecke ist damit auch kuerzer: der Satz fuellt
       sich schneller.

       Eigene Werte fuer mobil: dort ist der Block relativ zum Fenster viel
       hoeher, deshalb beginnt es spaeter im Bild (95 %) und endet frueher
       (70 %). Und weniger Nachlauf im scrub - auf kurzer Strecke faellt jedes
       Zehntel Verzoegerung als Traegheit auf. */
    var worte = gsap.utils.toArray('.statement__wort');
    if (worte.length) {
      gsap.matchMedia()
        /* 24.10.2026: die Strecke ist etwa doppelt so lang wie vorher. Sie
           endet, wenn die Mitte der Ueberschrift knapp ueber der Bildmitte
           steht - der Satz ist also noch dunkel, bevor man ihn dort liest
           (Regel vom 10.10.). Der Nachlauf von 0,5 s laesst die Fuellung dem
           Daumen weich folgen statt ruckartig mitzuspringen; auf der langen
           Strecke wirkt das nicht mehr traege. */
        .add('(min-width: 48rem)', function () {
          return statementFuellung(worte, 'top 95%', 'center 48%', 0.5);
        })
        .add('(max-width: 47.9375rem)', function () {
          return statementFuellung(worte, 'top 100%', 'center 46%', 0.5);
        });
    }

    /* 3 Ueberschriften: einmal zeilenweise hinter der Kante hoch. Kein Fade. */
    gsap.utils.toArray('[data-maske]').forEach(function (el) {
      /* 11.10.2026: die oberste Ueberschrift steht sofort und faehrt nicht hoch (Ladezeit, Kevin). */
      if (el.tagName === 'H1') { el.style.visibility = 'visible'; return; }
      inZeilen(el);
      el.style.visibility = 'visible';
      gsap.from(el.querySelectorAll('.zeile__innen'), {
        yPercent: 108,
        duration: 0.7,
        ease: 'power3.out',
        stagger: 0.07,
        scrollTrigger: { trigger: el, start: 'top 86%', once: true }
      });
    });

    /* 5 Sorten-Finder, Hauptmoment: beim Filtern heben sich die passenden
       Dosen mit demselben Pop an wie im Hero. Die uebrigen werden GEDIMMT,
       nicht ausgeblendet - das Raster bleibt stehen und jede Sorte bleibt
       anklickbar. Die Logik selbst steht weiter unten und laeuft auch ohne
       GSAP; hier haengt nur die Bewegung dran. */
    if (window.FLAVRBLOOM_FINDER) {
      window.FLAVRBLOOM_FINDER.pop = function (karten) {
        gsap.fromTo(karten,
          { y: 0, scale: 1 },
          { y: -10 * W, scale: 1.03, duration: 0.32, ease: 'flavrPop',
            stagger: 0.05, yoyo: true, repeat: 1, overwrite: 'auto' });
      };
    }

    /* 6 So einfach, Hauptmoment: die vierzig Schuesseln erscheinen Reihe fuer
       Reihe, zehn auf einmal. */
    gsap.utils.toArray('[data-schuesseln]').forEach(function (liste) {
      var stuecke = liste.querySelectorAll('li');
      if (!stuecke.length) return;
      liste.classList.add('js-reihen');
      gsap.to(stuecke, {
        opacity: 1, duration: 0.3, ease: 'power2.out',
        stagger: { each: 0.045, grid: [4, 10], from: 'start', axis: 'y' },
        scrollTrigger: { trigger: liste, start: 'top 88%', once: true }
      });
    });

    /* 6b Frischware je Dose (Kevin, 10.10.2026): die Gramm-Zahlen zaehlen
       einmal kurz hoch, wenn sie ins Bild kommen. Vorher steht die echte
       Zahl da, damit beim schnellen Scrollen nie eine leere oder falsche Zahl
       zu sehen ist. Bei reduzierter Bewegung laeuft dieser Teil gar nicht. */
    gsap.utils.toArray('[data-zaehlen]').forEach(function (el) {
      var m = /^(\d+)(.*)$/.exec(el.textContent.trim());
      if (!m) return;
      var ziel = parseInt(m[1], 10), rest = m[2], wert = { n: 0 };
      ScrollTrigger.create({
        trigger: el, start: 'top 88%', once: true,
        onEnter: function () {
          gsap.fromTo(wert, { n: Math.round(ziel * 0.35) }, {
            n: ziel, duration: 1.1, ease: 'power2.out',
            onUpdate: function () { el.textContent = Math.round(wert.n) + rest; },
            onComplete: function () { el.textContent = ziel + rest; }
          });
        }
      });
    });

    /* 7 Vorher-Nachher-Regler, Hauptmoment: beim ersten Sichtbarwerden faehrt
       der Regler einmal langsam nach rechts und zurueck zur Mitte. Danach
       gehoert er der Bedienung. */
    if (window.FLAVRBLOOM_REGLER) {
      var rAbschnitt = document.querySelector('.regler');
      if (rAbschnitt) {
        ScrollTrigger.create({
          trigger: rAbschnitt, start: 'top 72%', once: true,
          onEnter: function () { window.FLAVRBLOOM_REGLER.vorfuehren(); }
        });
      }
    }

    /* 8 Sternekueche, Hauptmoment: die sechs Figuren ploppen nacheinander auf. */
    gsap.utils.toArray('[data-figuren]').forEach(function (streifen) {
      var bilder = streifen.querySelectorAll('.figurkarte__bild');
      if (!bilder.length) return;
      streifen.classList.add('js-ploppen');
      gsap.fromTo(bilder,
        { opacity: 0, y: 18 * W, scale: 0.88 },
        { opacity: 1, y: 0, scale: 1, duration: 0.5, ease: 'flavrPop',
          stagger: 0.09,
          scrollTrigger: { trigger: streifen, start: 'top 86%', once: true } });
    });

    /* 9 Abschluss, Hauptmoment: die sechs Dosen ploppen nacheinander auf.
       Erst die drei hinten, dann die drei vorn - so baut sich die Gruppe von
       hinten nach vorn auf, wie sie auch raeumlich steht. Der Baustein steht
       auf ALLEN Seiten, deshalb laeuft das hier und nicht in seite.js allein
       fuer die Startseite. */
    gsap.utils.toArray('[data-dosen]').forEach(function (gruppe) {
      var hinten = gruppe.querySelectorAll('.dose--back');
      var vorn = gruppe.querySelectorAll('.dose--front');
      if (!hinten.length && !vorn.length) return;
      gruppe.classList.add('js-ploppen');
      var tl = gsap.timeline({
        scrollTrigger: { trigger: gruppe, start: 'top 85%', once: true }
      });
      tl.fromTo(hinten,
        { opacity: 0, y: 26 * W, scale: 0.9 },
        { opacity: 1, y: 0, scale: 1, duration: 0.5, ease: 'flavrPop', stagger: 0.1 }, 0);
      tl.fromTo(vorn,
        { opacity: 0, y: 30 * W, scale: 0.9 },
        { opacity: 1, y: 0, scale: 1, duration: 0.5, ease: 'flavrPop', stagger: 0.1 }, 0.16);
    });

    /* 10 Angebot: die beiden Karten kommen gestaffelt, nicht zugleich. */
    var karten = gsap.utils.toArray('[data-karte]');
    if (karten.length) {
      gsap.from(karten, {
        y: 26 * W, opacity: 0, duration: 0.6, ease: 'power3.out', stagger: 0.09,
        scrollTrigger: { trigger: karten[0].closest('.abschnitt'), start: 'top 78%', once: true }
      });
    }

    /* 11 Footer.

       Hier stand der Footer-Reveal: der Footer klebte am Fensterboden, die
       Seite bekam unten einen Platzhalter in Footerhoehe und denselben Wert
       als negativen Abstand, damit sie sich beim Scrollen darueber
       hinwegschiebt.

       Das ist RAUS. Der Trick hat dreimal etwas kaputtgemacht - zuletzt lag
       die Seite mit ihrem Platzhalter ueber dem Footer, auf allen sechs
       Seitentypen, und der Footer war nirgends anklickbar. Den Eindruck, dass
       sich etwas darueberschiebt, liefert jetzt ohnehin der Sticky-Stack.

       Der Footer ist ein ganz normaler Block am Seitenende. Ohne JavaScript
       ist er da, mit JavaScript ist er da, auf allen 34 Seiten.
       scripts/pruefung/seitenende.mjs misst nach, dass er wirklich
       anklickbar ist und nicht nur im Markup steht. */

    ScrollTrigger.refresh();
    if (F.lenis) F.lenis.resize();
  }

  /* --------------------------------------------------------------- Starten */
  /* ?ruhe zeigt alles im Endzustand, ohne Scroll-Bindung. Nur fuer Screenshots:
     eine Ganzseitenaufnahme friert scrollgebundene Momente sonst mittendrin
     ein und zeigt halb gefuellte Texte. */
  if (reduce.matches || /[?&]ruhe\b/.test(location.search)) {
    alleSichtbar();
    return;
  }
  /* SOFORT aufbauen, nicht erst auf die Schriften warten.
   *
   * Der Pin von ScrollTrigger schiebt einen Platzhalter in den Fluss und macht
   * das Dokument dadurch um sieben Bildhoehen laenger. Passiert das erst nach
   * document.fonts.ready, also nach dem ersten Bild, verschiebt sich die
   * gesamte Seite darunter - gemessen ein CLS von 1,00, der schlechteste
   * moegliche Wert. Bauen wir vor dem ersten Bild auf, ist der Platzhalter von
   * Anfang an da und es verschiebt sich nichts.
   *
   * Die Masse, die von den Schriften abhaengen, holt das Nachmessen in
   * js/scroll.js (window load + fonts.ready) wieder ein. */
  aufbauen();
})();
